import { render } from "./CertificateOzonCertificates.vue?vue&type=template&id=410acbe8"
import script from "./CertificateOzonCertificates.vue?vue&type=script&lang=js"
export * from "./CertificateOzonCertificates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__